import React, { memo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardContent,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import { StatusArrow } from 'components';

const useStyles = makeStyles(theme => ({
    root: {},
    header: {},
    content: {
        padding: '0 !important'
    },
    table: {
        [theme.breakpoints.down('md')]: {
            tableLayout: 'fixed'
        }
    },
    td: {
        textAlign: 'center',
        padding: '6px 2px',
        border: `1px solid ${theme.palette.grey.A100}`
    },
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    status: {
        marginRight: theme.spacing(1)
    },
    up: {
        color: theme.palette.error.main
    },
    down: {
        color: theme.palette.info.main
    },
    middle: {
        marginLeft: theme.spacing(-1),
        color: theme.palette.black
    },
    caption: {
        marginLeft: theme.spacing(1)
    }
}));

const Ranking = memo(props => {
    const { className, term, data, ...rest } = props;
    const classes = useStyles(props);
    const termLabel = {
        daily: 'date',
        weekly: 'week',
        monthly: 'month'
    };

    if (!data) return null;

    return (
        <>
            <Card {...rest} className={clsx(classes.root, className)}>
                <CardContent className={classes.content}>
                    <Grid container spacing={1}>
                        {data.map((ranking, i) => (
                            <Grid item key={i} lg={6} md={12} xs={12}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                className={classes.td}
                                                colSpan={3}>
                                                <strong>
                                                    {ranking.category}
                                                </strong>
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                reference {termLabel[term]}
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                comparison {termLabel[term]}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.td}>
                                                Rank
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                Diff
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                ECDI <br />
                                                Point
                                            </TableCell>
                                            <TableCell className={classes.td}>
                                                ECDI <br />
                                                Point
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ranking.data.map((data, j) => (
                                            <TableRow hover key={j}>
                                                <TableCell
                                                    className={classes.td}>
                                                    {data.ranking}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}>
                                                    {data.platform}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}>
                                                    <div
                                                        className={
                                                            classes.statusContainer
                                                        }>
                                                        <StatusArrow
                                                            className={
                                                                classes.status
                                                            }
                                                            size="sm"
                                                            type={
                                                                data.change
                                                                    .status
                                                            }
                                                        />
                                                        <Typography
                                                            className={
                                                                classes[
                                                                    data.change
                                                                        .status
                                                                ]
                                                            }
                                                            variant="body2">
                                                            {data.change
                                                                .ranking === 0
                                                                ? null
                                                                : data.change
                                                                      .ranking}
                                                        </Typography>
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}>
                                                    {data.standardDateECDIPoint}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.td}>
                                                    {
                                                        data.comparisonDateECDIPoint
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
});

Ranking.propTypes = {
    className: PropTypes.string,
    term: PropTypes.string,
    data: PropTypes.any
};

export default Ranking;
